import { motion } from "framer-motion";
import { Helmet } from "react-helmet";

export default function AboutPage() {
  return (
    <main className="text-gray-800 bg-white mt-4">
      <Helmet>
        
        <meta
          name="description"
          content="Discover the story behind Codexa, our mission to drive innovation, and the passionate team creating cutting-edge software solutions."
        />
        <meta
          name="keywords"
          content="About Codexa, software development, custom software, IT solutions, software house, Codexa team, innovation, technology"
        />
        <meta name="author" content="Codexa Software House" />

        {/* Open Graph */}
        <meta property="og:title" content="About Us | Codexa Software House" />
        <meta
          property="og:description"
          content="Learn more about Codexa's mission, values, and the innovative minds behind our technology-driven solutions."
        />
        <meta
          property="og:image"
          content="https://www.codexa.com/images/about-preview.jpg"
        />
        <meta property="og:url" content="https://www.codexa.com/about" />
        <meta property="og:type" content="website" />

        {/* Twitter Card */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="About Codexa | Our Story & Values" />
        <meta
          name="twitter:description"
          content="Explore Codexa’s mission, values, and commitment to building impactful digital solutions for modern businesses."
        />
        <meta
          name="twitter:image"
          content="https://www.codexa.com/images/about-preview.jpg"
        />

        {/* Canonical URL */}
        <link rel="canonical" href="https://www.codexa.com/about" />
      </Helmet>

      {/* Hero Section */}
      {/* Optional: Add a hero banner for visual appeal */}

      {/* About Content Section */}
      <section className="py-16 px-6 max-w-6xl mx-auto space-y-12">
        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-10"
        >
          <div>
            <h2 className="text-3xl font-semibold mb-4 text-indigo-600">
              Our Mission
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              At Codexa, we are driven by the belief that technology should be a
              catalyst for growth. Our mission is to help businesses unlock
              their full potential through tailored digital solutions. Whether
              it's building custom software, optimizing operations, or
              implementing cutting-edge technologies, we are dedicated to
              delivering tangible results that matter.
            </p>
          </div>
          <div>
            <img
              src="/about1.jpeg"
              alt="Our Mission"
              className="rounded-2xl shadow-lg"
            />
          </div>
        </motion.div>

        <motion.div
          initial={{ x: -50, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="grid md:grid-cols-2 gap-10 pt-2"
        >
          <div>
            <img
              src="/about2.jpeg"
              alt="Our Values"
              className="rounded-2xl shadow-lg h-2/3 w-full"
            />
          </div>
          <div>
            <h2 className="text-3xl font-semibold mb-4 text-indigo-600 mt-4">
              Our Values
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed">
              Integrity, innovation, and collaboration form the core of who we
              are. We believe that the best solutions emerge when we work
              closely with our clients, understand their needs, and bring fresh,
              creative ideas to the table. Every project we take on is a
              partnership, and we take pride in fostering long-lasting
              relationships built on trust and shared success.
            </p>
          </div>
        </motion.div>
      </section>
    </main>
  );
}
